import styled from "styled-components";

export const AddContainer = styled.div`
  height: 280px;
  width: 320px;
  background-color: #212529;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  position: fixed;
  margin-top: 390px;
  justify-content: space-around;
  border: 1px solid white;
  @media (min-width: 740px) {
    margin-top: 250px;
    margin-left: 420px;
  }
`;
